<template>
  <div>
    <div class="content">
      <el-form status-icon label-width="160px">
        <el-form-item label="新token" prop="password">
          <el-input v-model="token" />
        </el-form-item>
        <el-form-item>
          <div style="margin-top: 20px; text-align: end;">
            <el-button @click="$emit('cancel')">取消</el-button>
            <el-button type="primary" @click="updateToken()">确定</el-button>
          </div>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>

import { updateBaiduToken } from '@/api/baiduAD'

export default {
  props: {
    // eslint-disable-next-line vue/prop-name-casing
    update_token_id: {
      type: Number,
      default: 0
    },
    // eslint-disable-next-line vue/prop-name-casing
    old_token: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      token: ''
    }
  },
  watch: {
    old_token(newVal, oldVal) {
      this.token = newVal
    }
  },
  created() {
    this.token = this.old_token
  },
  methods: {
    async updateToken() {
      const data = await updateBaiduToken({
        token: this.token,
        user_id: this.update_token_id
      })
      // eslint-disable-next-line eqeqeq
      if (data.code == 0) {
        this.$message({
          type: 'success',
          message: '更新成功'
        })
        this.$emit('cancel')
        this.$emit('updateList')
      }
    }
  }
}
</script>

<style scoped>

.item{
    margin-bottom: 12px;
    display: flex;
    align-items: center;
}

.title{
    display: inline-block;
    width: 90px;
    text-align: right;
    margin-right: 30px;
}

.el-input{
  width: 200px;
}

.exhibition{
    width: 100px;
    height: 100px;
    border-style: dotted;
    border-width: 1px;
    position: relative;
    cursor: pointer;
}

.exhibition::after{
   content: '';
    position: absolute;
    width: 50%;
    height: 1px;
    background-color: black;
    top: 50%;
    transform: translate(50%, 50%);
}

.exhibition::before{
    content: '';
    position: absolute;
    width: 1px;
    height: 50%;
    background-color: black;
    left: 50%;
    transform: translate(50%, 50%);
}

.exhibition:hover{
  border-color: #509cda;
}

.exhibition:hover::after{
   background-color:#509cda;
}

.exhibition:hover::before{
   background-color:#509cda;
}

.pictureContent{
    display: flex;
    flex-wrap: wrap;
}

.pictureContent_item{
    margin-right: 10px;
    cursor: pointer;
    position: relative;
}

.pictureContent_item_img{
    width: 100px;
    height: 100px;
}

.pictureContent_item:hover .meng{
     display: flex;
     align-items: center;
     justify-content: center;
     position: absolute;
     width: 100%;
     height: 100%;
     background-color: rgba(200, 200, 200, 0.7);
     top: 0px;
     left: 0px;
}

.meng{
  display: none;
}
</style>
